import { request } from "../../../services/api"
import type { BaseApiResponse, BasePagination } from "../../../types/api.ts"
import type { SupplierListItem } from "../types/types.ts"
import type {
  CreateSupplierData,
  GetSuppliersParams,
  UpdateSupplierData
} from "./services.types.ts"

const BASE_URL = "/supplier/suppliers"

export const getSuppliers = (params?: GetSuppliersParams) =>
  request.api.get<BasePagination<SupplierListItem>, BaseApiResponse<unknown>>(
    `${BASE_URL}/`,
    params
  )

export const getSupplierDetails = (id: string) =>
  request.api.get<SupplierListItem, BaseApiResponse<unknown>>(
    `${BASE_URL}/${id}/`
  )

export const createSupplier = (data: CreateSupplierData) =>
  request.api.post<BaseApiResponse<SupplierListItem>, BaseApiResponse<unknown>>(
    `${BASE_URL}/`,
    data
  )

export const updateSupplier = ({ id, ...rest }: UpdateSupplierData) =>
  request.api.patch<BaseApiResponse<SupplierListItem>, BaseApiResponse<unknown>>(
    `${BASE_URL}/${id}/`,
    rest
  )

export const deleteSupplier = (id: string) =>
  request.api.delete<BaseApiResponse<null>, BaseApiResponse<unknown>>(
    `${BASE_URL}/${id}/`
  )
